<template>
  <div id="student-list">
    <div class="mt-5 container" :class="{ 'admin-wrap': listCount > 0 }">
      <div v-if="listCount > 0" class="datatable_group">
        <data-tables :data="list">
          <el-table-column
            v-for="studentListInfo in studentList"
            :prop="studentListInfo.prop"
            :label="studentListInfo.label"
            :key="studentListInfo.prop"
            sortable="custom"
          >
          </el-table-column>
          <el-table-column align="center">
            <template #header>
              <K2Text>Action</K2Text>
            </template>
            <template #default="scope">
              <k2-button size="mini" @onclick="handleStudentPost(scope.$index, scope.row)">View Student Post </k2-button>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../../data/datasource'
import K2Text from '../k2Text/k2Text'
import K2Button from '../k2Button/k2Button'

export default {
  name: 'K2StudentList',
  components: { K2Button, K2Text },
  props: ['staffID', 'studentList', 'studList', 'dateRange'],
  data() {
    return {
      list: [],
      listCount: '',
    }
  },
  async mounted() {
    this.fetch().then()
  },
  methods: {
    async fetch() {
      this.$vs.loading()
      try {
        // console.log(this.dateRange);
        const response = await DataSource.shared.getStudentWithPendingCourse(this.studList, '', '', '', '', '', '', '', '', '', this.staffID)
        if (response) {
          if (response.code === '88') {
            window.location.replace('/')
          } else if (response.code === '99') {
            this.$notify.error({
              title: 'Error',
              message: 'Search Student: Error',
            })
          } else if (response.code === '2') {
            this.$notify.error({
              title: 'No Record',
              message: 'No Student Found',
            })
          } else {
            this.list = response.Table
            this.listCount = response.Table && response.Table.length
            this.list.forEach(object => {
              const found = this.studentFilterItem.find(d => d === object.Status)
              if (!found) {
                this.studentFilterItem.push(object.Status)
              }
            })
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },
    handleStudentPost(index, row) {
      this.$router.push({ name: 'ActivityPage', params: { Student: row, StaffID: this.staffID, dateRange: this.dateRange } })
    },
  },
}
</script>

<style></style>
